module.exports = "<div class=\"forExitButton\">\n  <button id=\"exitBtnThankYou\" mat-icon-button (click)=\"closeSnack()\">\n      <mat-icon >clear</mat-icon>\n  </button>\n</div>\n<h5 class=\"thankYou\">{{'thankYou' | translate}}</h5>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/calendar/races/r1/thankYou.html
// module id = ./src/app/calendar/races/r1/thankYou.html
// module chunks = main